import request from '@/axios'
import { sm2 } from 'sm-crypto'

export const initBaseDataApi = () => {
  return request.get({ url: '/data/initBaseData' })
}

const publicK =
  '04fae5d1245e4ad10c91cf116610876b8d63de97c4e1460d32115cd9ed0ea3fae53376ea955c717ac1869295cb744b19eb14ec0bb2009f9a295bfa398e75c3699c'
const cipherMode = 1
const privateK = 'd1961a03aa3769f851b5c71ab05e9911120a3ab4907d05aff0104dca5f71a692'

export const encryptData = (data) => {
  if (data && typeof data === 'string') {
    return sm2.doEncrypt(data, publicK, cipherMode)
  }
}

export const decryptData = (data) => {
  return sm2.doDecrypt(data, privateK, cipherMode)
}

export const serverDecrypt = (params: any) => {
  return request.post({ url: '/monitor/security/serverDecrypt', data: params })
}

export const frontEncrypt = (params: any) => {
  return request.post({ url: '/monitor/security/frontEncrypt', data: params })
}
